import { UserInterviewsActionTypes } from './types'

interface UserInterviewsState {
  regularInterviews: any[]
  avaInterviews: any[]
  isLoading: boolean
  error: string | null
}

const initialState: UserInterviewsState = {
  regularInterviews: [],
  avaInterviews: [],
  isLoading: false,
  error: null,
}

export default function userInterviewsReducer(
  state = initialState,
  action: UserInterviewsActionTypes
): UserInterviewsState {
  switch (action.type) {
    case 'USER_INTERVIEWS/GET_USER_INTERVIEWS':
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case 'USER_INTERVIEWS/GET_USER_INTERVIEWS_SUCCESS':
      return {
        ...state,
        regularInterviews: action.payload.regular_interviews,
        avaInterviews: action.payload.ava_interviews,
        isLoading: false,
        error: null,
      }
    case 'USER_INTERVIEWS/GET_USER_INTERVIEWS_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}


